import React from 'react';
import Fader from 'react-fader';
import { useHistory } from 'react-router';
import { Route, Redirect, useParams } from 'react-router-dom';
import Switch from 'react-router-transition-switch';

import ApplicationLayout from 'components/ApplicationLayout';
import useIsMobile from 'hooks/useIsMobile';
import GuestNotAuthorized from 'screens/components/Login/forms/GuestNotAuthorized';
import Root from 'screens/components/Root';
import InviteContainer from 'screens/containers/Invite';
import Login from 'screens/containers/Login';
import LoginEmail from 'screens/containers/LoginEmail';
import LoginSso from 'screens/containers/LoginSso';
import ForgotPassword from 'screens/containers/ForgotPassword';
import ResetPassword from 'screens/containers/ResetPassword';
import OAuthDefaultContainer from 'screens/containers/OAuthDefaultContainer';
import RegistrationOnboardingContainer from 'screens/containers/RegistrationOnboarding';
import TravelerProfile from 'screens/containers/TravelerProfile';
import CreateResellerContainer from 'screens/containers/CreateReseller';
import CreateResellerForm from 'screens/components/CreatedReseller';

const PublicRouter = () => {
  const isMobile = useIsMobile();

  return (
    <Switch
      render={({ children }) => (
        <ApplicationLayout>
          <Fader viewStyle={isMobile ? { height: '100vh' } : {}}>{children}</Fader>
        </ApplicationLayout>
      )}
    >
      <Route path="/corporate/invite" component={InviteContainer} />
      <Route path="/corporate/registration" component={RegistrationOnboardingContainer} />
      <Route exact path="/corporate/login-email" component={LoginEmail} />
      <Route exact path="/corporate/login/sso" component={LoginSso} />
      <Route exact path="/corporate/login/forgotpassword" component={ForgotPassword} />
      <Route exact path="/corporate/login/resetpassword" component={ResetPassword} />
      <Route exact path="/corporate/login/changePassword" component={ResetPassword} />
      <Route path="/corporate/login" component={Login} />
      <Route exact path="/corporate/travelerProfile" component={TravelerProfile} />
      <Route exact path="/corporate/" component={Root} />
      <Route exact path="/corporate/auth-rappi" component={OktaAuthNsLogin} />
      <Route exact path="/corporate/auth/:token" component={OauthNsLogin} />
      <Route exact path="/corporate/auth2/:token" component={OauthNsLogin2} />
      <Route exact path="/corporate/oauth-login" component={OAuthDefaultContainer} />
      <Route exact path="/corporate/oauth-registration" component={OAuthDefaultContainer} />
      <Route exact path="/corporate/oauth-invite" component={OAuthDefaultContainer} />
      <Route exact path="/corporate/login-not-authorized" component={GuestNotAuthorized} />
      <Route exact path="/corporate/createReseller" component={CreateResellerContainer} />
      <Route exact path="/corporate/createResellerForm" component={CreateResellerForm} />
      <Redirect to="/corporate" />
    </Switch>
  );
};

export function OauthNsLogin() {  
  const history = useHistory();
  const { token } = useParams<{ token: string }>();  
  const from = location.search.toLowerCase().includes('from');
  let fromParamUrl = '';

  if (from) {
    const queryParams = new URLSearchParams(location.search);
    const fromParam = queryParams.get('from');
    fromParamUrl = `&from=${fromParam}`;
  }
  history.push(`/corporate/?token=${token}${fromParamUrl}`);
  return <></>;
}

function OauthNsLogin2() {
  
  const history = useHistory();
  const { token } = useParams<{ token: string }>();
  const isFromCreateReseller = location.search.toLowerCase().includes('createresellerform');
  history.push(`/corporate/createresellerform?token=${token}`);
  return <></>;
}

function OktaAuthNsLogin() {
  /*const history = useHistory();
  const { token, email, name, lastname } = useParams<{ token: string, email: string, name: string, lastname: string }>();
  console.log(token);
  console.log(email);
  console.log(name);
  console.log(lastname);
  history.push(`/corporate/?token=${token}&email=${email}&name=${name}&lastname=${lastname}`);*/
  return <></>;
}

export default PublicRouter;
